import { useSettings } from "~/store/settings";

const formatMobile = (mobile: string) => {
	const settings = useSettings();
	return settings?.config?.countries[0].countryDialingCode?.replace("+", "") + Number(mobile).toString();
};

export default formatMobile;
